var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#949CAF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.805 2.529L3.47.195c-.26-.26-.682-.26-.942 0L.195 2.53c-.26.26-.26.682 0 .942.26.26.683.26.943 0l1.195-1.195v13.057c0 .368.299.667.667.667.368 0 .667-.299.667-.667V2.276l1.195 1.195c.13.13.3.196.471.196.171 0 .342-.065.472-.196.26-.26.26-.682 0-.942zM11.805 12.529c-.26-.26-.683-.26-.943 0l-1.195 1.195V.667C9.667.299 9.368 0 9 0c-.368 0-.667.299-.667.667v13.057l-1.195-1.195c-.26-.26-.683-.26-.943 0-.26.26-.26.682 0 .942l2.334 2.334c.13.13.3.195.471.195.17 0 .341-.065.471-.195l2.334-2.334c.26-.26.26-.682 0-.942z",
    transform: "translate(2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sortArrow.2bc708df.svg";
export { ForwardRef as ReactComponent };